ko.protectedObservable = function (initialValue) {
  var _actualValue = ko.observable(initialValue);
  var _tempValue = initialValue;

  var result = ko.dependentObservable(
    {
      read: function () {
        return _actualValue();
      },
      write: function (newValue) {
        _tempValue = newValue;
      }
    });

  result.commit = function () {
    if (_tempValue !== _actualValue()) {
      _actualValue(_tempValue);
    }
  };

  result.reset = function () {
    _actualValue.valueHasMutated();
    _tempValue = _actualValue();
  };

  return result;
};

// Use this binding handler to change HTML visibility attribute. The KO visible binding uses display:none, which is not always what is needed.
ko.bindingHandlers.unhidden = (function () {
  function setVisibility (element, valueAccessor) {
    var unhidden = ko.utils.unwrapObservable(valueAccessor());
    $(element).css('visibility', unhidden ? 'visible' : 'hidden');
  }
  return { init: setVisibility, update: setVisibility };
})();

ko.bindingHandlers.contextMenu =
        {
          init: function (element, valueAccessor, allBindingsAccessor, viewModel) {
            var id = $(element).attr('id');
            var value = valueAccessor();

            // Remove extra instances of the context menu container
            if ($('body').children('#' + id).length) {
              $(element).remove();
              return;
            }

            $(element).detach().appendTo('body'); // The menu container should be a child of the body element

            $(value.targetSelector).jeegoocontext($(element).attr('id'), value.options);
          },
          update: function (element, valueAccessor, allBindingsAccessor, viewModel) {
          }
        };

ko.bindingHandlers.readStatus =
        {
          init: function (element, valueAccessor, allBindingsAccessor, viewModel) {
            ko.bindingHandlers.readStatus.updateDom(element, valueAccessor, allBindingsAccessor, viewModel, false);
          },
          update: function (element, valueAccessor, allBindingsAccessor, viewModel) {
            ko.bindingHandlers.readStatus.updateDom(element, valueAccessor, allBindingsAccessor, viewModel, true);
          },
          updateDom: function (element, valueAccessor, allBindingsAccessor, viewModel, animate) {
            var DURATION = 300;
            var $elem = $(element);
            var $label = $elem.find('.dst_label-thumbnail').parent();
            var $image = $elem.find('.dst_image-thumbnail').parent();
            var labelLeft;
            var imageLeft;
            var value = valueAccessor();
            var left;

            // Values match the CSS class values
            if (value()) {
              labelLeft = '67%';
              imageLeft = '0%';
            } else {
              labelLeft = '0%';
              imageLeft = '33%';
            }

            // Don't animate if already in place
            if (value()) {
              if ($label.hasClass('read')) {
                left = parseInt($label.css('margin-left'), 10);

                if (left > $label.width()) {
                  return;
                }
              }
            } else {
              if (!$label.hasClass('read')) {
                if (($label.css('margin-left') === undefined || $label.css('margin-left') === 'auto' || $label.css('margin-left').length === 0) || $label.css('margin-left') === '0px') {
                  return;
                }
              }
            }

            if (animate) {
              $label.animate(
                {
                  marginLeft: labelLeft
                }, DURATION, function () {
                  $label.toggleClass('read');
                });

              $image.animate(
                {
                  marginLeft: imageLeft
                }, DURATION, function () {
                  $image.toggleClass('read');
                });
            } else {
              $label.css('margin-left', labelLeft).toggleClass('read');
              $image.css('margin-left', imageLeft).toggleClass('read');
            }
          }
        };

//
//
// These methods enable users to drag/drop slides across trays
//
ko.bindingHandlers.multiSortableList =
        {
          init: function (element, valueAccessor, allBindingsAccessor, vm) {
            // ko.bindingHandlers.multiSortableList.settings = valueAccessor().settings;
            ko.bindingHandlers.multiSortableList.settings.isMultiTray = valueAccessor().multiTray;
            ko.bindingHandlers.multiSortableList.settings.numTrays = vm.settings.traysPerMulti;
            ko.bindingHandlers.multiSortableList.settings.slidesPerDisplay = vm.settings.slidesPerTray * vm.settings.traysPerMulti;
          },
          settings: {},
          update: function (element, valueAccessor, allBindingsAccessor, vm) {
            if (vm.settings.enableReordering == false) {
              return;
            }

            var sortablesConnect = '.dst_slide-col';
            var $source = $(element);

            $source.sortable(
              {
                connectWith: sortablesConnect,
                forceHelperSize: true,
                tolerance: 'intersect',
                helper: 'clone', // Need a clone instead of the original (the default) so I can use it to prevent the list from collapsing when dragging to a connected list
                opacity: 0.75,
                placeholder: 'dst_slide-placeholder-hover',
                scroll: false,
                start: function (event, ui) {
                  var isMultiTray = $('#dst_EditTrays').is(':visible');
                  var tray, slideSelector, groupSelector, col, colPos, pos;

                  var isPosNegControl = ui.item.closest('.posNegSlide').length !== 0;

                  col = (isPosNegControl ? 0 : ui.item.closest('ul').hasClass('dst_slide-col-1') ? 0 : 1);
                  colPos = (isPosNegControl ? (ui.item.closest('div').hasClass('positive') ? 0 : 1) : ui.item.index());
                  pos = (10 * col) + colPos;

                  // Restore to normal size
                  // arizzini: fixed the resizing of the
                  $(ui.helper).find('div').stop().removeClass('dst_hovered-slide-holder').removeAttr('style');

                  // Store the start position data with the li
                  if (isMultiTray) {
                    tray = ui.item.closest('.dst_tray').parent().index();
                  } else {
                    // arizzini: in the case of pos or neg control slides we should be using the -1 value;
                    tray = isPosNegControl ? -1 : vm.displayTray().index;
                  }

                  ui.item.data('StartTray', tray).data('StartCol', col).data('StartPos', pos);

                  // Add disabled appearance to slides in different group
                  if (isMultiTray) {
                    slideSelector = '#dst_EditTrays .dst_slide-col-1:visible, #dst_EditTrays .dst_slide-col-2:visible';
                    groupSelector = '#dst_EditTrays .dst_group-col:visible';
                  } else {
                    slideSelector = '.dst_tray .dst_slide-col-1:visible, .dst_tray .dst_slide-col-2:visible';
                    groupSelector = '.dst_tray .dst_group-col:visible';
                  }

                  $(slideSelector).children(':visible').not(ui.placeholder).not(ui.helper).each(function (slideIdx) {
                    if (isMultiTray) {
                      slideIdx += vm.activeCase().editTraysVm.startTrayIndex() * vm.settings.slidesPerTray;
                    }
                    var selectedSlide = vm.getSelectedSlide(vm);
                    var vmSlide = vm.allSlides[slideIdx];
                    // Diable all slides not in the source slide's group
                    $(this) // select the slide holders
                      .add($(groupSelector).children().eq(slideIdx))
                      .toggleClass('ui-state-disabled', (!!vmSlide) && (vmSlide.group.id() !== selectedSlide.group.id()));
                  });

                  ui.item.tmplItem().data.isDragged(true);
                },
                receive: function (event, ui) {

                },
                over: function (event, ui) {
                  // Can't use this event because hover may fire when over invalid target, then won't fire again when over valid target
                },
                out: function (event, ui) {
                },
                sort: function (event, ui) {
                  // DST_Sort(vm, event, ui, false);
                },
                change: function (event, ui) {

                },
                beforeStop: function (event, ui) {
                  if (ui.item.index() < vm.settings.slidesPerColumn) {
                    if (ui.placeholder.closest('.posNegSlide').length !== 0) {
                      // If is is a +/- control movement we set the ToTrayIndex = -1
                      ui.item.data('ToTrayIndex', -1);
                    } else {
                      ui.item.data('ToTrayIndex', ui.placeholder.parent().parent().parent().parent().index());
                    }

                    return true;
                  }
                },
                update: function (event, ui) {
                },
                stop: function (event, ui) {
                  var isMultiTray = $('#dst_EditTrays').is(':visible');
                  var trayOffset;

                  if (isMultiTray) {
                    trayOffset = vm.activeCase().editTraysVm.startTrayIndex();
                  } else {
                    trayOffset = 0;
                  }

                  var vil = jQuery.getVilInstance();

                  var isPosNegControl = ui.item.closest('.posNegSlide').length !== 0;

                  var slidesPerTray = vm.settings.slidesPerTray;
                  var fromTrayIndex = ui.item.data('StartTray') + trayOffset;
                  var fromTrayPos = ui.item.data('StartPos');
                  var fromPos = (fromTrayIndex < 1) ? fromTrayPos : (fromTrayIndex * slidesPerTray) + fromTrayPos;

                  var toTrayIndex;
                  if (isMultiTray) {
                    toTrayIndex = ui.item.data('ToTrayIndex');
                    toTrayIndex += trayOffset;
                  } else {
                    toTrayIndex = isPosNegControl ? -1 : vm.displayTray().index;
                  }

                  var toCol = (isPosNegControl ? 0 : ui.item.closest('ul').hasClass('dst_slide-col-1') ? 0 : 1);
                  var colPos = (isPosNegControl ? (ui.item.closest('div').hasClass('positive') ? 0 : 1) : ui.item.index());

                  var toTrayPos = (toCol * vm.settings.slidesPerColumn) + colPos;
                  var toPos = (toTrayIndex < 1) ? toTrayPos : ((toTrayIndex * slidesPerTray) + toTrayPos);
                  if (toPos >= vm.allSlides.length) {
                    toPos = vm.allSlides.length - 1;
                  }

                  ui.item.removeData('StartTray').removeData('StartPos').removeData('ToTrayIndex');

                  // Remove disabled classes
                  $('.dst_tray').find('.ui-state-disabled').animate(
                    {
                      opacity: 1
                    }, 600, function () {
                      $(this).removeClass('ui-state-disabled').css('opacity', '');
                    });

                  $.each(vm.allSlides, function () {
                    this.isDragged(false);
                    this.isDraggedOver(false);
                  });

                  // arizzini: fugbugz #19532 : fixed the issue of uScope breaks when it is loading and a slide is moved in the dst.
                  if (vm.cantChangeSlide) {
                    $(this).sortable('cancel');
                    return;
                  }

                  if (fromTrayIndex < 0) {
                    if (fromTrayIndex == toTrayIndex) {
                      if (fromPos > 1 || toPos > 1 || fromPos == toPos) {
                        ui.item.tmplItem().data.isDragged(false);
                        $(this).sortable('cancel');
                        return;
                      }

                      var PosNegPrevious = (toPos == 0 ? 'positive' : 'negative');
                      var PosNegDragged = (fromPos == 0 ? 'positive' : 'negative');

                      var previousSlide = vm.getPosNegSlide(PosNegPrevious);
                      var draggedSlide = vm.getPosNegSlide(PosNegDragged);

                      // arizzini: this is the fix for knockout not generating the element if it was cache.
                      // hence we need to remove all the elements and re-adding the in.
                      vm.posNegSlides.splice(0, 2);

                      if (previousSlide) {
                        previousSlide.sampleType = PosNegDragged;
                        previousSlide.isDragged(false);
                        vm.posNegSlides.push(previousSlide);
                      }

                      draggedSlide.isDragged(false);
                      draggedSlide.sampleType = PosNegPrevious;

                      vm.posNegSlides.push(draggedSlide);

                      vil.uScopeImageUpdate('state', vm.posNegSlides());
                    } else {
                      var PosNeg = (fromPos == 0 ? 'positive' : 'negative');

                      draggedSlide = vm.getPosNegSlide(PosNeg);
                      draggedSlide.sampleType = 'patient';
                      draggedSlide.isValidSlide = true;
                      draggedSlide.isPinned = false;
                      draggedSlide.isDragged(false);

                      // arizzini: if the +/- control slide does not belong to the DST do not add it back in.
                      if (vm.activeCase().recordId == draggedSlide.originated) {
                        // arizzini: adding slide back to its previous position.
                        vm.allSlides.splice(draggedSlide.positionIndex, 0, draggedSlide);
                        var lastIdx = vm.allSlides.length - 1;

                        vil.getDst().reorderSlides(vm, draggedSlide.positionIndex, lastIdx);
                      }

                      var indexForDelete = vm.posNegSlides.indexOf(draggedSlide);
                      vm.posNegSlides.splice(indexForDelete, 1);

                      vil.uScopeImageUpdate('remove', {'image': draggedSlide});
                    }
                  } else {
                    if (toTrayIndex >= 0) {
                      // Prevent move to different group
                      if (vm.allSlides[fromPos].group.id() !== vm.allSlides[toPos].group.id()) {
                        ui.item.tmplItem().data.isDragged(false);
                        $(this).sortable('cancel');
                        return;
                      }

                      if (fromPos == toPos) {
                        // where is nothing to do.

                      } else {
                        // Valid move, so update the Viewmodel

                        vm.moveSlide(vm, fromPos, toPos);

                        vil.getDst().reorderSlides(vm, fromPos, toPos);
                      }
                    } else {
                      // arizzini: we need to check if the the current position we are trying to inset is already taken.
                      PosNeg = (toPos == 0 ? 'positive' : 'negative');

                      previousSlide = vm.getPosNegSlide(PosNeg);
                      draggedSlide = vm.allSlides[fromPos];

                      if (draggedSlide.isSelected()) {
                        if (previousSlide) {
                          var draggedSlideIdx = fromPos;
                          var lastSlideIdx = vm.allSlides.length - 1;

                          // we have a previous slide, we need to swap them
                          previousSlide.sampleType = 'patient';
                          previousSlide.isValidSlide = true;
                          previousSlide.isPinned = false;
                          previousSlide.isDragged(false);
                          previousSlide.isSelected(true);

                          // arizzini: adding to the slides
                          vm.allSlides.splice(previousSlide.positionIndex, 0, previousSlide);
                          // arizzini: remove the previousSlide from the +/- control
                          indexForDelete = vm.allSlides.indexOf(draggedSlide);
                          vm.allSlides.splice(indexForDelete, 1);

                          draggedSlide.sampleType = PosNeg;
                          // arizzini: disabling selecting the image once it is on the +/- control.
                          draggedSlide.isValidSlide = false;
                          draggedSlide.isPinned = true;
                          draggedSlide.isSelected(false);
                          draggedSlide.isDragged(false);

                          // arizzini: addin the dragged to the pos/neg
                          vm.posNegSlides.push(draggedSlide);
                          // arizzini: remove the dragged from the slide
                          indexForDelete = vm.posNegSlides.indexOf(previousSlide);
                          vm.posNegSlides.splice(indexForDelete, 1);

                          var images = [previousSlide, draggedSlide];

                          vil.getDst().reorderSlides(vm, draggedSlideIdx, lastSlideIdx);
                          vil.uScopeImageUpdate('state', images);
                        } else {
                          // we have to to a state change and a add

                          // arizzini: move slides from the DST to +/-Control
                          draggedSlide.sampleType = PosNeg;
                          // arizzini: disabling selecting the image once it is on the +/- control.
                          draggedSlide.isValidSlide = false;
                          draggedSlide.isPinned = true;
                          draggedSlide.isSelected(false);
                          draggedSlide.isDragged(false);

                          // arizzini: adding to the + / - control slide

                          vm.posNegSlides.push(draggedSlide);

                          draggedSlideIdx = fromPos;
                          lastSlideIdx = vm.allSlides.length - 1;
                          vm.allSlides.splice(fromPos, 1);
                          var blankSlide = vm.createBlank(vm, lastSlideIdx);
                          vm.allSlides.push(blankSlide);

                          // arizzini: lets rearrange the DST
                          vil.getDst().reorderSlides(vm, draggedSlideIdx, lastSlideIdx);

                          vil.uScopeImageUpdate('state', {'image': draggedSlide});

                          // arizzini: we need to add the next slide hence passing null.
                          vm.setSelectedSlide(vm, vm.allSlides[draggedSlide.positionIndex], null);
                        }
                      } else {
                        // this is not a selected slide
                        if (previousSlide) {
                          lastIdx = vm.allSlides.length - 1;
                          previousSlide.sampleType = 'patient';
                          previousSlide.isValidSlide = true;
                          previousSlide.isPinned = false;
                          previousSlide.isDragged(false);
                          previousSlide.isSelected(false);

                          vm.allSlides.splice(previousSlide.positionIndex, 0, previousSlide);
                          // remove the last one.
                          vm.allSlides.splice(lastIdx + 1, 1);

                          indexForDelete = vm.posNegSlides.indexOf(previousSlide);
                          vm.posNegSlides.splice(indexForDelete, 1);

                          // arizzini: move slides from the DST to +/-Control
                          draggedSlide.sampleType = PosNeg;
                          // arizzini: disabling selecting the image once it is on the +/- control.
                          draggedSlide.isValidSlide = false;
                          draggedSlide.isPinned = true;
                          draggedSlide.isSelected(false);
                          draggedSlide.isDragged(false);

                          // arizzini: adding to the + / - control slide
                          vm.posNegSlides.push(draggedSlide);

                          indexForDelete = vm.allSlides.indexOf(draggedSlide);
                          vm.allSlides.splice(indexForDelete, 1);

                          blankSlide = vm.createBlank(vm, lastIdx);
                          vm.allSlides.push(blankSlide);

                          // arizzini: lets rearrange the DST
                          vil.getDst().reorderSlides(vm, previousSlide.positionIndex, lastIdx);
                          vil.uScopeImageUpdate('replace', {'image': previousSlide}, {'image': draggedSlide});
                        } else {
                          // arizzini: move slides from the DST to +/-Control
                          draggedSlide.sampleType = PosNeg;
                          // arizzini: disabling selecting the image once it is on the +/- control.
                          draggedSlide.isValidSlide = false;
                          draggedSlide.isPinned = true;
                          draggedSlide.isSelected(false);
                          draggedSlide.isDragged(false);

                          // arizzini: adding to the + / - control slide
                          vm.posNegSlides.push(draggedSlide);

                          draggedSlideIdx = fromPos;
                          lastSlideIdx = vm.allSlides.length - 1;
                          vm.allSlides.splice(fromPos, 1);
                          blankSlide = vm.createBlank(vm, lastSlideIdx);
                          vm.allSlides.push(blankSlide);

                          // arizzini: lets rearrange the DST
                          vil.getDst().reorderSlides(vm, fromPos, lastSlideIdx);

                          vil.uScopeImageUpdate('add', {'image': draggedSlide});
                        }
                      }
                    }
                  }
                }
              });
          }
        };



// WEBPACK FOOTER //
// ./src/slide-tray/jquery.dst-extensions.js